import React, { useState, useEffect } from 'react';
import {
  Field,
  reduxForm,
} from 'redux-form';
import {
  Button,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import './CommentForm.scss';
import * as _ from 'lodash';
import renderTextField from '../../_shared/utils/renderTextField';

const MAX_COMMENT_LENGTH = 1000;
let disableSubmit = true;

const validateCommentTitle = (values) => {
  if (!values.commentTitle) {
    return 'Comment name Required';
  }
  const withoutLeadingSpaces = values.commentTitle.replace(/^\s+/g, '');
  const withoutTrailingSpaces = values.commentTitle.replace(/\s+$/g, '');
  if (withoutTrailingSpaces.length > 40) {
    return 'Comment name exceeds 40 characters';
  }
  if (withoutLeadingSpaces === '') {
    return 'Comment name contains only whitespaces';
  }
  return null;
};

const validateCommentText = (values, isProjectLevel) => {
  if (!values.commentText) {
    return 'Comment text Required';
  }
  const withoutLeadingSpacesText = values.commentText.replace(/^\s+/g, '');
  if (isProjectLevel && values.commentText.length > MAX_COMMENT_LENGTH) {
    return `Comment text exceeds ${MAX_COMMENT_LENGTH} characters`;
  }
  if (!isProjectLevel && values.commentText.length > MAX_COMMENT_LENGTH) {
    return `Comment text exceeds ${MAX_COMMENT_LENGTH} characters`;
  }
  if (withoutLeadingSpacesText === '') {
    return 'Comment text contains only whitespaces';
  }
  return null;
};

const updateDisableSubmitState = (errors) => {
  if (_.isEmpty(errors)) {
    disableSubmit = false;
  } else {
    disableSubmit = true;
  }
};

const validate = (values, props) => {
  const errors = {};
  const { isProjectLevel, isReply } = props;

  if (!isReply) {
    const titleError = validateCommentTitle(values);
    if (titleError) {
      errors.commentTitle = titleError;
    }
  }

  const textError = validateCommentText(values, isProjectLevel);
  if (textError) {
    errors.commentText = textError;
  }

  updateDisableSubmitState(errors);
  return errors;
};

export const EditCommentForm = (props) => {

  const { handleSubmit, isReply, onCancel, commentText, title, commentId, initialValues } = props;
  const existingText = commentText || (initialValues && initialValues.commentText) || '';
  const [form, setValues] = useState({
    commentText: existingText,
    commentTitle: title || (initialValues && initialValues.commentTitle) || '',
  });
  const [commentTextLength, setCommentTextLength] = useState(existingText.length);

  useEffect(() => {
    const text = commentText || (initialValues && initialValues.commentText) || '';
    setCommentTextLength(text.length);
  }, [commentText, initialValues]);
  const updateField = (e) => {
    if (e.target.name === 'commentText') {
      setCommentTextLength(e.target.value.length);
    }
    setValues({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <Field
        component={renderTextField}
        id="outlined-button-file"
        type="hidden"
        className="input"
        value={commentId}
        name="commentId"
      />
      {!isReply && (
        <div className="comment-name">
          <Field
            id="outlined-button-file"
            type="text"
            className="input"
            value={form.commentTitle}
            name="commentTitle"
            component={renderTextField}
            onChange={updateField}
          />
        </div>
      )}
      <div className="comment-main">
        <Field
          component={renderTextField}
          id="comment"
          type="text"
          className="comment-input"
          value={form.commentText}
          name="commentText"
          multiline
          rows="6"
          onChange={updateField}
        />
        <div className='char-counter'>
          {Math.max(0, MAX_COMMENT_LENGTH - commentTextLength)} characters remaining
        </div>
      </div>
      <div className="buttons">
        <Button
          testId="edit-comment-cancel-btn"
          className="cancel-button"
          type="button"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          testId="edit-comment-save-btn"
          disabled={disableSubmit}
          className="submit-button"
          type="submit"
        >
          Save
        </Button>
      </div>
    </form>
  );
};

EditCommentForm.defaultProps = {
  isReply: false,
  commentText: '',
  title: '',
  commentId: '',
};

EditCommentForm.propTypes = {
  isReply: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  commentText: PropTypes.string,
  title: PropTypes.string,
  commentId: PropTypes.number,
  isProjectLevel: PropTypes.bool.isRequired,
};

export default reduxForm({
  form: 'editCommentForm',
  enableReinitialize: true,
  validate,
})(EditCommentForm);
